var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlertRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 -0.0000012 70 70",
    enableBackground: "new 0 -0.0000012 70 70",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FF6375",
    cx: 35,
    cy: 35,
    r: 35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    fill: "#FFFFFF",
    d: "M31.8170547,48.8101845c0-1.8127403,1.2931061-3.1844482,3.1584625-3.1844482 c1.811615,0,3.1568871,1.3717079,3.1568871,3.1844482v2.5807648c0,1.7574005-1.3452721,3.1844521-3.1568871,3.1844521 c-1.8653564,0-3.1584625-1.4270515-3.1584625-3.1844521V48.8101845z M31.5056343,19.2127323 c-0.0505867-2.0307369,1.4496078-3.7881365,3.469883-3.7881365c1.9143677,0,3.5710564,1.7573996,3.5188904,3.7881365 l-0.4663391,19.1100636c-0.1549225,1.8110619-1.397438,3.1291122-3.1062965,3.1291122 c-1.7072792,0-2.9497986-1.3733902-3.0019646-3.1291122L31.5056343,19.2127323z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertRed);
export default __webpack_public_path__ + "static/media/icon_alert_red.5421bd41d2ab1e4b9c3496a359168ddf.svg";
export { ForwardRef as ReactComponent };